import { render, staticRenderFns } from "./InteractiveItem.vue?vue&type=template&id=e195f842&"
import script from "./InteractiveItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InteractiveItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports